// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"b0362681","21":"6a33ea0d","130":"e6bd29d6","170":"70931d9e","233":"cfb32db4","289":"46579436","377":"8a8ee4d2","495":"2973a347","571":"57429f1e","666":"e2d512ba","690":"7c4e6f9f","717":"d33d3a9f","934":"697826c7"}[chunkId] + ".chunk.js";
};